// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Excerpt.scss
// module id = 612
// module chunks = 72 88